import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import esCatalog from "@dojomgt/i18n/locales/es.json";
import enCatalog from "@dojomgt/i18n/locales/en.json";
import esAdmin from "./es-admin.json";
import enAdmin from "./en-admin.json";

const STORAGE_KEY = "dojomgt.locale";

function resolveInitialLocale(): "es" | "en" {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === "es" || stored === "en") return stored;
  } catch {
    // localStorage unavailable — fall through
  }
  return "es";
}

type Dict = Record<string, unknown>;
const isPlainObject = (v: unknown): v is Dict =>
  typeof v === "object" && v !== null && !Array.isArray(v);

/**
 * Recursively merge the admin catalog onto the shared one. Nested namespaces
 * (e.g. `common`, `discipline`) are combined rather than replaced, so admin
 * only overrides the specific leaf keys it defines and shared-only keys under
 * the same namespace stay reachable. Admin wins on leaf conflicts.
 */
function deepMerge(base: Dict, override: Dict): Dict {
  const out: Dict = { ...base };
  for (const [key, ov] of Object.entries(override)) {
    const bv = out[key];
    out[key] = isPlainObject(bv) && isPlainObject(ov) ? deepMerge(bv, ov) : ov;
  }
  return out;
}

void i18n.use(initReactI18next).init({
  resources: {
    es: { translation: deepMerge(esCatalog as Dict, esAdmin as Dict) },
    en: { translation: deepMerge(enCatalog as Dict, enAdmin as Dict) }
  },
  lng: resolveInitialLocale(),
  fallbackLng: "es",
  interpolation: { escapeValue: false }
});

export default i18n;
